// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"346b95c2","848":"dab97273"}[chunkId] + ".chunk.css";
};